export const buyers = [
  { name: 'Carlos M.', country: 'Mexico', flag: '🇲🇽' },
  { name: 'Andrés R.', country: 'Colombia', flag: '🇨🇴' },
  { name: 'Javier P.', country: 'Spain', flag: '🇪🇸' },
  { name: 'Luis F.', country: 'Argentina', flag: '🇦🇷' },
  { name: 'Diego S.', country: 'Chile', flag: '🇨🇱' },
  { name: 'Miguel Á.', country: 'Peru', flag: '🇵🇪' },
  { name: 'José L.', country: 'Ecuador', flag: '🇪🇨' },
  { name: 'Ricardo V.', country: 'Venezuela', flag: '🇻🇪' },
  { name: 'Fernando G.', country: 'Uruguay', flag: '🇺🇾' },
  { name: 'Héctor D.', country: 'Guatemala', flag: '🇬🇹' },
  { name: 'Raúl C.', country: 'Dominican Republic', flag: '🇩🇴' },
  { name: 'Pablo T.', country: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Óscar N.', country: 'Bolivia', flag: '🇧🇴' },
  { name: 'Sergio A.', country: 'Paraguay', flag: '🇵🇾' },
]
